import React, { FC, memo } from 'react';

import { DialogItem } from '@smart-tv/components/dialog';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import { LiveTvChannel } from '@smart-tv/typings/content';
import { DraggableProvided } from 'react-beautiful-dnd';

import { SELECTED_ITEM_FOCUS_KEY } from './favorites-edit-helpers';
import FavoritesEditSelectedChannelsRowOrderButtons from './favorites-edit-selected-channels-row-order-buttons';
import { FavoritesEditSelectedChannelsOrderButtonValue } from './favorites-edit-selected-channels-row-order-buttons';
import styles from '../favorites.module.scss';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';

interface ChannelRowProps {
  channel: LiveTvChannel;
  index: number;
  draggableProvided: DraggableProvided;
  focusedButtonSid: number | undefined;
  isLast: boolean;
  onPointerLeave: () => void;
  onPointerEnter: () => void;
  onFocus: (layout: { top: number }) => void;
  onToggle: () => void;
  onMove: (direction: FavoritesEditSelectedChannelsOrderButtonValue) => void;
}

export const SelectedChannelRow: FC<ChannelRowProps> = ({
  channel,
  index,
  draggableProvided,
  focusedButtonSid,
  isLast,
  onPointerLeave,
  onPointerEnter,
  onFocus,
  onToggle,
  onMove
}: ChannelRowProps) => {

  return (
    <div
      id={String(channel.sid)}
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      className={styles['favorites-edit-root--row']}
      onPointerLeave={onPointerLeave}
    >
      <div className={styles['favorites-edit-root--num']}>
        <Typography variant="h6">{index + 1}.</Typography>
      </div>

      <div className={styles['favorites-edit-root--item']} {...draggableProvided.dragHandleProps}>
        <DialogItem
          hasBackground={true}
          hasIcon={true}
          noMargin={true}
          onPointerEnter={onPointerEnter}
          focusKey={SELECTED_ITEM_FOCUS_KEY + channel.sid}
          focusedContainer={channel.sid === focusedButtonSid}
          onFocus={onFocus}
          onEnterPress={onToggle}
          onClick={onToggle}
          dataTestId={testIds.favorites.edit.selectedChannelsItem}
        >
          <img
            className={styles['favorites-edit-root--logo']}
            src={channel.icon}
            alt={channel.name}
          />
          <Typography noWrap>{channel.name}</Typography>
        </DialogItem>
      </div>
      {focusedButtonSid === channel.sid && !IS_BROWSER && (
        <FavoritesEditSelectedChannelsRowOrderButtons
          onClick={onMove}
          disableUp={index === 0}
          disableDown={isLast}
        />
      )}
    </div>
  );
};

export default memo(SelectedChannelRow);
